/**
 * Download from a URL with a local filename. When the server sends
 * Content-Disposition without a file extension (common for WhatsApp audio stored
 * before the filename fix), append one from the attachment hint or Content-Type.
 */
export async function downloadAttachment({ url, type, extension }) {
  if (!url || !type) {
    throw new Error('Invalid download parameters');
  }

  const response = await fetch(url, { cache: 'no-store' });

  if (!response.ok) {
    throw new Error(`Download failed: ${response.status}`);
  }

  const blobData = await response.blob();
  const contentType = response.headers.get('content-type');
  const normalizedExt = extension ? String(extension).replace(/^\./, '') : null;
  const subtype = contentType?.split('/')?.[1]?.split(';')?.[0]?.trim() || null;
  const fileExtension = normalizedExt || subtype || type;

  const dispositionHeader = response.headers.get('content-disposition');
  const filenameMatch = dispositionHeader?.match(
    /filename\*=UTF-8''([^;\n]+)|filename="([^"]*)"|filename=([^;\n]+)/i
  );
  const rawDispositionName = (
    filenameMatch?.[1] ||
    filenameMatch?.[2] ||
    filenameMatch?.[3] ||
    ''
  ).trim();

  let decodedDisposition = rawDispositionName;
  if (decodedDisposition) {
    try {
      decodedDisposition = decodeURIComponent(decodedDisposition);
    } catch {
      /* keep raw */
    }
  }

  let filename =
    decodedDisposition || `attachment_${Date.now()}.${fileExtension}`;

  if (!filename.includes('.') && fileExtension) {
    filename = `${filename}.${fileExtension}`;
  }

  const blobUrl = URL.createObjectURL(blobData);
  const link = Object.assign(document.createElement('a'), {
    href: blobUrl,
    download: filename,
    style: 'display: none',
  });

  document.body.append(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(blobUrl);
}
